import { Informations, InformationSectionTwo } from '../../components';
import { homeObjectOne, homeObjectTwo } from './Data';

const Products = () => {
  return (
    <>
      <InformationSectionTwo {...homeObjectOne} />
      <Informations {...homeObjectTwo} />
    </>
  );
}

export default Products;
